import { useEffect, useRef, useState } from 'react';

export const useFormTabLock = (formKey, options = {}) => {
    const { title = 'Formulario' } = options;
    const [isLocked, setIsLocked] = useState(false);
    const channelRef = useRef(null);

    useEffect(() => {
        const tabId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        channelRef.current = new BroadcastChannel(`sizesoftx_${formKey}`);

        channelRef.current.onmessage = (event) => {
            if (event.data.type === 'CHECK_TAB' && event.data.tabId !== tabId) {
                channelRef.current.postMessage({
                    type: 'TAB_ALREADY_OPEN',
                    tabId,
                    title,
                    formKey
                });
            }
            if (event.data.type === 'TAB_ALREADY_OPEN' && event.data.tabId !== tabId) {
                setIsLocked(true);
            }
        };

        channelRef.current.postMessage({ type: 'CHECK_TAB', tabId });

        return () => {
            if (channelRef.current) {
                channelRef.current.close();
            }
        };
    }, [formKey, title]);

    return { isLocked };
};